import "../css/theme.css";

import './globals';

import "./libs.js";
import "./utils/breakpointVariables.js"

import "./pages/cart"
import "./partials/cart-drawer/index"
import "./partials/predictive-search"
//EX-1229
// import "./partials/gtmInit"
import "./partials/gtmProductListInit"
import "./utils/dictionary.js"
import "./utils/toggleContent"
import "./utils/notImplementedYet"
import "./partials/drawer"
import "./partials/input-select"
import "./partials/filter"
import "./utils/collectionRefferer"
import "./utils/cartIconAnimation.js"
